import {
  FitTextModule,
  ButtonModule,
  TextsFilterComponent,
  FormFieldModule,
} from '@shared/components/games';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MorelaxControllerComponent } from './morelax-controller/morelax-controller.component';
import { MorelaxSettingsComponent } from './morelax-settings/morelax-settings.component';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MorelaxCorrectAnswerPreviewComponent } from './morelax-preview/morelax-answer-preview/morelax-answer-preview.component';
import { MorelaxExamplePreviewComponent } from './morelax-preview/morelax-example-preview/morelax-example-preview.component';
import { MorelaxParametersPreviewComponent } from './morelax-preview/morelax-parameters-preview/morelax-parameters-preview.component';
import { MorelaxUserAnswerPreviewComponent } from './morelax-preview/morelax-user-answer-preview/morelax-user-answer-preview.component';
import { PicturesFilterModule } from '@shared/components/games/pictures-filter/pictures-filter.module';
import { GamesSharedModule } from '@games/games-shared/games-shared.module';
import { GameCountdownComponent } from '@games/shared/game-countdown/game-countdown.component';

@NgModule({
  declarations: [
    MorelaxControllerComponent,
    MorelaxSettingsComponent,
    MorelaxCorrectAnswerPreviewComponent,
    MorelaxExamplePreviewComponent,
    MorelaxParametersPreviewComponent,
    MorelaxUserAnswerPreviewComponent,
  ],
  exports: [
    MorelaxControllerComponent,
    MorelaxSettingsComponent,
    MorelaxCorrectAnswerPreviewComponent,
    MorelaxExamplePreviewComponent,
    MorelaxParametersPreviewComponent,
    MorelaxUserAnswerPreviewComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    FitTextModule,
    TextsFilterComponent,
    PicturesFilterModule,
    GamesSharedModule,
    GameCountdownComponent,
    FormFieldModule,
  ],
})
export class MorelaxModule {}
